import { render, staticRenderFns } from "./GameMode.vue?vue&type=template&id=0efe1355"
import script from "./GameMode.vue?vue&type=script&lang=js"
export * from "./GameMode.vue?vue&type=script&lang=js"
import style0 from "./GameMode.vue?vue&type=style&index=0&id=0efe1355&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports